module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/SS-success-vector-df8d528315c753747411a92d4a2ae232.png";